<template>
  <div>
    <v-dialog
      v-model="dialog"
      width="500"
      persistent
    >
      <v-card>
        <v-card-title
          class="header info"
          primary-title
        >
          <b>{{ $t('bots.linkBot') }}</b>
        </v-card-title>

        <v-card-text
          v-if="!done"
        >
          <v-flex
            v-if="needsNew()"
            xs12
          >
            <v-select
              v-model.trim="bot"
              :items="userBots"
              :item-text="formatName"
              :item-value="'id'"
              :item-disabled="item => ( item.manager !== null )"
              :error-messages="SelectionErrors"
              name="bot"
              :label="$t('bots.chooseBot')"
              required
              @change="$v.bot.$touch()"
              @blur="$v.bot.$touch()"
            />
          </v-flex>
          <v-flex 
            v-else 
            xs12 
            class="text-center"
          >
            {{ $t('bots.dontHaveBots') }}        
          </v-flex>
        </v-card-text>

        <v-card-text
          v-else
          class="text-center"
        >
          <b>{{ $t('bots.joinedMsg1') }}</b>{{ $t('bots.joinedMsg2') }}
          <b>{{ $t('bots.joinedMsg3') }}</b>. 
          {{ $t('bots.joinedMsg4') }}
          <b><a @click.prevent="dialog = false;$router.push('/traderbots/mybots')">{{ $t('bots.joinedMsg5') }}</a></b>
        </v-card-text>

        <v-divider />

        <v-card-actions 
          v-if="!done && needsNew()"
        >
          <v-spacer />
          <v-btn
            text
            :disabled="loading"
            @click="dialog = false"
          >
            {{ $t('globals.cancelButton') }}
          </v-btn>
          <v-btn
            color="primary"
            :disabled="loading"
            :loading="loading"
            @click="save()"
          >
            {{ $t('bots.linkButton') }}
          </v-btn>
        </v-card-actions>
        <v-card-actions
          v-else
        >
          <v-btn
            text
            :disabled="loading"
            @click="dialog = false"
          >
            {{ $t('globals.closeButton') }}
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>  
  </div>
</template>

<script>

import { validationMixin } from 'vuelidate'
import { required, maxLength} from 'vuelidate/lib/validators'

import USER_BOTS_QUERY from '@/graphql/queries/UserBots.gql';
import CONNECT_BOT_MUTATION from '@/graphql/mutations/ConnectBot.gql'

export default {
  name: 'ConnectBot',
  mixins: [validationMixin],
  props: {
    showDialog: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      bot: null,
      loading: false,
      done: false
    }
  },
  computed: {
    dialog: {
      get() {
        return this.showDialog
      },
      set(val) {
        this.$parent.connectDialog = val
      }
    },
    SelectionErrors () {
      const errors = []
      if (!this.$v.bot.$dirty) return errors
      !this.$v.bot.required &&
        errors.push(this.$t('bots.chooseBot'))
      return errors
    },
  },
  watch: {
    showDialog(n, o) {
      if(n) {
        this.bot = null
        this.$v.$reset()
        this.done = false
      }
    }
  },
  methods: {
    needsNew() {
      if (_.isEmpty(this.userBots)) return false
      let manager = _.mapValues(this.userBots, 'manager')
      let val = _.indexOf(_.values(manager), null)
      return val == -1 ? false : true
    },
    formatName(item) {
      let name = item.account_name 
      name += item.manager !== null ? ` (${this.$t('bots.connectedTo')} ${item.manager.name})`: ''
      return name
    },
    save() {
      this.$v.$touch()
      if(!this.$v.$invalid) {
        this.loading = true;

        let params = {
          user_bot_id: this.bot,
          bot_manager_id: this.$parent.selectedManager,
        }
 
        this.$apollo.mutate({
          mutation: CONNECT_BOT_MUTATION,
          variables: params,
        }).then(data => {
          this.loading = false
          this.$apollo.queries.userBots.refetch()
          this.done = true
        }).catch(error => {
          this.errorHandler(error)
          this.loading = false
        })
      }
    }
  },
  validations: {
    bot: {
      required
    },
  },
  apollo: {
    userBots: {
      query: USER_BOTS_QUERY
    }
  }
}
</script>

<style>

</style>
